module.exports = __webpack_public_path__ + "static/img/joinus.e8b8b338.png";